import Axios from '@/components/api/axios.js'

export default {
  /**
   *检查登录名
   * @param {String} userCode 登录名
   * @param {String} oldPassword 旧密码
   * @param {String} newPassword 新密码
   * @param {String} loginType 登录类型
   */
  changePW: (userCode, oldPassword, newPassword, loginType, success, failure) => {
    Axios.post('/user/changePW.do', {
      userCode,
      oldPassword,
      newPassword,
      loginType
    }, respon => {
      //记录token
      localStorage.setItem("token", respon.pkid)
      sessionStorage.setItem("token", respon.pkid)
      success(respon)
    }, failure);
  },
  /**
   *检查登录名
   * @param {String} userCode 登录名
   */
  checkUser: (userCode, success, failure) => {
    Axios.post('/user/checkUser.do', {
      userCode
    }, respon => {
      success(respon)
    }, failure);
  },
  /**
   * 登录
   * @param {String} userCode 用户登录名
   * @param {String} password 用户密码
   * @param {String} loginType 登录方式
   * @param {String} captcha 验证码
   * @param {int} isStrongPassword 强验证
   */
  login: (userCode, password, loginType, captcha, isStrongPassword, success, failure) => {
    Axios.post('/user/login.do', {
      userCode,
      password,
      loginType,
      captcha,
      isStrongPassword
    }, respon => {
      //记录token
      localStorage.setItem("token", respon.pkid)
      sessionStorage.setItem("token", respon.pkid)
      success(respon)
    }, failure);
  },
  /**
   * 注销
   */
  logout: (success, failure) => {
    Axios.post('/user/logout.do', {}, success, failure);
  },
  /**
   * 查询用户信息
   * @param {String} userCode 用户登录名
   */
  findUserInfoByUserCode: (userCode, success, failure) => {
    Axios.post('/user/findUserInfoByUserCode.do', {
      userCode,
    }, success, failure);
  },
  /**
   * 修改密码
   * @param {String} oldPsw 旧密码
   * @param {String} newPsw 新密码
   */
  updatePSW: (oldPsw, newPsw, success, failure) => {
    Axios.post('/user/updatePSW.do', {
      oldPsw,
      newPsw,
    }, success, failure);
  },
  /**
   * 获取单位下的用户列表
   * @param {String} unitId 单位id
   */
  findUserByUnitId: (unitId, success, failure) => {
    Axios.post('/user/findUserByUnitId.do', {
      unitId,
    }, success, failure);
  },
  /**
   * 当前登陆用户下的用户列表. workGroup页面
   */
  findUserByLoginUser: (success, failure) => {
    Axios.post('/user/findUserByLoginUser.do', {}, success, failure);
  },
  /**
   * 新建或者更新用户
   * @param {String} userid 用户id
   * @param {String} username 用户名称
   * @param {String} usercode 登录名
   * @param {String} password 密码
   * @param {String} mobile 手机号码
   * @param {String} telephone 座机号码
   * @param {String} entityid 所属单位id
   * @param {String} emailaddress 邮箱地址
   * @param {String} emailpsw 邮箱密码
   * @param {String} memo 备注
   * @param {String} roleIds 角色id 多个用逗号隔开
   * @param {String} rfid 唯一编号
   * @param {String} gender 性别
   * @param {String} address 住址
   * @param {String} reportDir 报表地址
   */
  saveUser: (userid, username, usercode, password, mobile, telephone, entityid, emailaddress, emailpsw, gender, address, memo, roleIds, isSSO, reportDir, tokenTime, success, failure) => {
    Axios.post('/user/saveUser.do', {
      userid,
      username,
      usercode,
      password,
      mobile,
      telephone,
      entityid,
      emailaddress,
      emailpsw,
      gender,
      address,
      memo,
      roleIds,
      isSSO,
      reportDir,
      tokenTime
    }, success, failure);
  },
  /**
   * 新建或者更新业主
   * @param {String} cardTypes 银行类型  多个用逗号隔开 与cardNumbers必须按顺序对应
   * @param {String} cardNumbers 银行卡号  多个用逗号隔开 与cardTypes必须按顺序对应
   */
  saveOwner: (userid, username, usercode, password, mobile, entityid, rfid, gender, address,
    isAutomaticBrake, amountOfArrears, cardType, cardNumber, balanceAlarm, roleIds, cardState, reportDir, accountTime, userShareRelations, success, failure) => {
    Axios.post('/user/saveUser.do', {
      userid,
      username,
      usercode,
      password,
      mobile,
      entityid,
      rfid,
      gender,
      address,
      isAutomaticBrake,
      amountOfArrears,
      cardType,
      cardNumber,
      balanceAlarm,
      roleIds,
      cardState,
      reportDir,
      accountTime,
      userShareRelations,
    }, success, failure);
  },
  /**
   * 新建或者更新员工
   * @param {String} education 学历
   * @param {String} entriTime 入职时间
   * @param {String} department 部门名称
   */
  saveStaff: (userid, username, mobile, entityid, rfid, gender, address, education, entriTime, department, reportDir, success, failure) => {
    Axios.post('/user/saveUser.do', {
      userid,
      username,
      mobile,
      entityid,
      rfid,
      gender,
      address,
      education,
      entriTime,
      department,
      reportDir
    }, success, failure);
  },
  /**
   * 获取所有已经存在是编号
   */
  getAllRfid: (success, failure) => {
    Axios.post('/user/getAllRfid.do', {}, success, failure);
  },
  /**
   * 删除用户信息
   * @param {String} id 用户id
   */
  deleteUserById: (id, success, failure) => {
    Axios.post('/user/deleteUserById.do', {
      id,
    }, success, failure);
  },

  /**
   * 用户补扣
   * @param {String} id 用户id
   * @param {String} balance 补扣金额
   * @param {String} desc 补扣原因
   * @param {String} type补扣类型
   */
  amountOfDeduction: (id, balance, desc, type, success, failure) => {
    Axios.post('/user/amountOfDeduction.do', {
      id,
      balance,
      desc,
      type
    }, success, failure);
  },

  /**
   * 绑定用户与权限
   * @param {String} userId 用户id
   * @param {String} rightIds 权限id集合
   */
  bindUserAndRight: (userId, rightIds, success, failure) => {
    Axios.post('/user/bindUserAndRight.do', {
      userId,
      rightIds
    }, success, failure);
  },
  /**
   * 单位用户树
   */
  getUserTree: (success, failure) => {
    Axios.post('/user/getUserTree.do', {}, success, failure);
  },
  /**
   * app注册用户
   */
  registerUser: (usercode, username, password, mobile, validateCode, searchId, roleIds, rfid, gender, address, cardTypes, cardNumbers, success, failure) => {
    Axios.post('/user/registerUser.do', {
      usercode,
      username,
      password,
      mobile,
      validateCode,
      searchId,
      roleIds,
      rfid,
      gender,
      address,
      cardTypes,
      cardNumbers,
    }, success, failure);
  },
  /**
   * 刷新token有效期到7天后，接口会返回剩余小时数
   */
  expireToken: (success, failure) => {
    Axios.post('/user/expireToken.do', {}, success, failure);
  },
  /**
   * 关联用户和角色接口
   * @param {string} userId  用户id
   * @param {String} roleIds  角色ids
   */
  bindUserAndRole: (userId, roleIds, success, failure) => {
    Axios.post('/user/bindUserAndRole.do', {
      userId,
      roleIds
    }, success, failure);
  },
  /**
   * 关联用户和设备接口
   * 
   * @param {String} type:edit_可控制设备/view_可查看设备
   * @param {String} userId  用户id
   * @param {String} deviceNos 设备no集合，多个用逗号隔开 
   */
  bindUserAndDevice: (type, userId, deviceNos, success, failure) => {
    Axios.post('/user/bindUserAndDevice.do', {
      type,
      userId,
      deviceNos
    }, success, failure)
  }
}